import InputCharCounter from "../InputCharCounter";
import EditableRateStar from "../EditableRateStar";
import CircleProgress from "../CircleProgress";
import {multiUpload} from "../image_uploader";
import ReviewModal from "../business/ReviewModal";

class PoiReview{

    constructor(rating){
        this.rating = rating || 0;
    }

    removeDialog(){
        $('.addReviewModal').remove();
    }

    showDialogReview(poiId){

        this.removeDialog();

        let reviewModal = new ReviewModal;
        let dialog = reviewModal.renderModal('Write a review');

        let poiPromise      = this.getPoi(poiId);
        let userPromise     = this.getUser();
        let rules           = this.getRules();
        let currentReview   = this.getCurrentReview(poiId);

        Promise.all([poiPromise, userPromise, rules, currentReview]).then(result => {

            let poi     = result[0];
            let user    = result[1];
            let rules   = result[2];
            let review  = result[3];

            console.log(poi);

            reviewModal.addBody(this.showFormReview(poi, user, rules, review));
            reviewModal.showModal();

            InputCharCounter();

        })

        return dialog;

    }

    getCurrentReview(poiId){
        return new Promise(resolve => {
            $.get('/ajax/poi.getUserReview', {poi_id: poiId}, function(d){
                let res = ParseResp(d);
                if(res && res.data.review){
                    resolve(res.data.review);
                }
            })
        })
    }

    getRules(){
        return new Promise(resolve => {
            $.get('/ajax/poi.getReviewRules', {}, function(d){
                let res = ParseResp(d);
                if(res){
                    resolve(res.data);
                }
            })
        })
    }

    getUser(){
        return new Promise(resolve => {
            $.get('/ajax/users.getCurrentUser', {fields: 'id,photo_50,url'}, function(d){
                let res = ParseResp(d);
                resolve(res.data.user);
            })
        })
    }

    getPoi(poiId){

        return new Promise(resolve => {
            $.get('/ajax/poi.getById', {
                id: poiId,
                fields: 'id,location'
            }, function(d){
                let res = ParseResp(d);
                resolve(res.data.poi);
            })
        })

    }

    showMoreOptions(review, rules, currentReview){

        let div = $('<div>' +
            '<div class="form-item">' +
                '<textarea name="text" id="text" class="textReview autosize form-control bg-d800" placeholder="Write your review" data-role="charcounter" data-maxlength="1500">' + review.text + '</textarea>' +
            '</div>' +
            '<div class="flex-row mb_20 flex-center gap_1 pl_10">' +
                '<div class="reviewTextProgress"></div>' +
                '<div class="fs-14 reviewTextProgress-message">Start writing a review</div>' +
            '</div>' +
            '<div class="form-item">' +
                '<div class="reviewImagesBox flex-row flex-wrap" id="images">' +
                    '<div class="file_upload_btn">' +
                        '<div class="upload-image-empty">' +
                            '<i class="icon-event_image fs-20"></i>' +
                            '<span class="fs-14">Add photo</span>' +
                            '<span class="fs-12 color-d540">min '+rules.images.min_size+' px</span>' +
                        '</div>' +
                        '<input type="file" name="filesUpload[]" class="filesUpload reviewImages" accept="image/*" data-mode="poi_review" multiple="" max="' + rules.images.max_files + '">' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div>' +
                '<button type="button" class="btn btn-blue saveReviewBtn mt_20">POST A REVIEW</button>' +
            '</div>' +
        '</div>');

        let circleProgress = new CircleProgress({
            size: 26,
            stroke: 3,
            radius: 11,
            showEmptyStroke: true
        });
        let circleElement = circleProgress.render();

        let textReview = div.find('.textReview');
        let reviewTextProgressMessage = div.find('.reviewTextProgress-message');

        let handleProgressText = function(obj){

            review.text         = obj.val();
            let len             = review.text.length;
            if(len > 100) len   = 100;

            let strokeColor = null;

            if(len === 0){
                reviewTextProgressMessage.html('Start writing a review');
                reviewTextProgressMessage.css('color', 'white');
            }else if(len < 16){
                reviewTextProgressMessage.html('Too short a review');
                reviewTextProgressMessage.css('color', '#FF0000');
                strokeColor = '#FF0000';
            }else if(len < 100){
                reviewTextProgressMessage.html('That\'s great, but it\'s better to elaborate');
                reviewTextProgressMessage.css('color', '#ffe200');
                strokeColor = '#ffe200';
            }else{
                reviewTextProgressMessage.html('Great, you can add a photo');
                reviewTextProgressMessage.css('color', '#30ef30');
                strokeColor = '#30ef30';
            }

            if(strokeColor){
                circleProgress.setStrokeColor(strokeColor);
            }
            circleProgress.update(len);

        }

        handleProgressText(textReview);

        textReview.on('input', function(){
            handleProgressText($(this));
        })

        div.find('.reviewTextProgress').prepend(circleElement);

        multiUpload(div.find(".reviewImages"), {
            size: 480,
            rules: rules.images,
            images: currentReview && currentReview.images ? currentReview.images : [],
            attachmentsContainer: div.find('.reviewImagesBox'),
            onLoadFile: file => {
                review.images.push(file.key)
            },
            onRemoveFile: file => {
                review.images = review.images.filter(key => key !== file.key)
            }
        });

        return div;

    }

    showFormReview(poi, user, rules, currentReview){

        let self = this;

        let review = {
            poi_id: poi.id,
            rating: this.rating,
            text: '',
            images: []
        };

        if(currentReview){
            // если передано значение из вне, значит оно обновилось до открытия формы
            // например при клике за звездочки за которым следует открытие формы
            review.rating = this.rating === 0 ? currentReview.rating : this.rating;
            review.text = currentReview.text;
            if(currentReview.images.length > 0){
                currentReview.images.forEach(image => {
                    review.images.push(image.key);
                })
            }
        }

        let form = $('<form class="businessReviewForm" id="businessReviewForm">' +
                '<div>' +
                    '<div class="flex-row flex-center gap_2 reviewUserInfo">' +
                        '<div class="reviewUserInfo-avatar"><img alt="' + user.username + ' photo" src="' + user.photo_50 + '"></div>' +
                        '<div class="reviewUserInfo-signature">' +
                            '<div>' + user.username + '</div>' +
                            '<div class="fs-12 color-d400">Published for all</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="editableRateContainer text-center">' +
                    '<div class="color-d400 fs-12 mt_5">Rate "' + poi.name + '"</div>' +
                '</div>' +
            '</form>');

        let editableRateStar = new EditableRateStar;
        let starsContainer = editableRateStar.getContainer();
        form.find('.editableRateContainer').prepend(starsContainer);

        starsContainer.on('onUpdate', function(e, rating){
            review.rating = rating;
        })

        starsContainer.on('onBeforeUpdate', function(e, rating){
            if(rating === 0){
                form.append(self.showMoreOptions(review, rules, currentReview));
                let saveBtn = form.find('.saveReviewBtn');
                saveBtn.on('click', function(){
                    $.post("/ajax/poi.saveReview", review, function(d){
                        let res = ParseResp(d, '#businessReviewForm');
                        if(res){
                            if(res.data.success === true){
                                self.removeDialog();
                            }
                        }
                    })
                })
            }
        })

        if(review.rating !== 0){
            editableRateStar.setRating(review.rating);
        }

        return form;

    }

}

export default PoiReview;